module.exports = __webpack_public_path__ + "img/glassquality_1.59a75deb.png";